import * as React from 'react';
import s from '../responsive.scss';
import classNames from 'classnames';
export var ShowOnDesktopOnly = function (props) {
    var classes = classNames(s.desktopOnly, props.className);
    return React.createElement("div", { className: classes }, props.children);
};
//# sourceMappingURL=ShowOnDesktopOnly.js.map